module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/ai289-e904fa96be148b24cf29f25aa123729c.jpg";